import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useVerifiedStatus } from '../hooks/useVerifiedStatus';
import { useResponsiveLayout } from '../hooks/useResponsiveLayout';

export default function MobileBottomNav() {
  const { isAuthenticated, user } = useAuth();
  const { verified } = useVerifiedStatus();
  const responsive = useResponsiveLayout();
  const location = useLocation();

  if (!isAuthenticated || !user || !responsive.isMobile) {
    return null;
  }

  const isActive = (path) => location.pathname === path;

  const navItem = (icon, label, path) => (
    <Link
      to={path}
      className={`flex flex-col items-center justify-center gap-1 py-3 px-4 transition-colors ${
        isActive(path)
          ? 'text-primary'
          : 'text-on-background/60 hover:text-on-background'
      }`}
    >
      <span className="text-xl">{icon}</span>
      <span className="text-[10px] font-medium">{label}</span>
    </Link>
  );

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 bg-surface border-t border-outline h-20 flex items-center justify-around z-40">
        {navItem('🏠', 'Home', '/dashboard')}
        {verified && navItem('📨', 'Invite', '/invite')}
        {navItem('🌳', 'Tree', '/genealogy')}
        {navItem('📦', 'Packages', '/wallet')}
        {navItem('📖', 'Guides', '/guides')}
      </nav>

      {/* Spacer to account for fixed bottom nav */}
      <div className="h-20" />
    </>
  );
}
